
import { Component } from '@angular/core';

@Component({
  selector: 'ui-side-menu-header',
  template: '<ng-content></ng-content>'
})
export class SideMenuHeaderComponent { }
